module.exports = __webpack_public_path__ + "img/logo.12a36e16.svg";